import { apiClient } from '../axios-instance';
import type { 
  RFQ, 
  RFQListResponse, 
  RFQQuote,
  UpdateRFQStatusRequest 
} from '../../../features/rfqs/types/rfq.types';

/**
 * RFQ Service
 * Handles all RFQ (Request for Quotation) related API calls
 */
export const rfqService = {
  /**
   * Get all RFQs with optional filters
   */
  async getAll(params?: {
    search?: string;
    status?: string;
    customer_id?: string;
    date_from?: string;
    date_to?: string;
    per_page?: number;
    page?: number;
  }): Promise<RFQListResponse> {
    const { data } = await apiClient.get('/admin/rfqs', { params });
    return data;
  },

  /**
   * Get RFQ by ID
   */
  async getById(id: string | number): Promise<{ success: boolean; data: RFQ }> {
    const { data } = await apiClient.get(`/admin/rfqs/${id}`);
    return data;
  },

  /**
   * Update RFQ status
   */
  async updateStatus(
    id: string | number,
    payload: UpdateRFQStatusRequest
  ): Promise<{ success: boolean; message: string; data: RFQ }> {
    const { data } = await apiClient.put(`/admin/rfqs/${id}/status`, payload);
    return data;
  },

  /**
   * Get quotes for an RFQ
   */
  async getQuotes(id: string | number): Promise<{ success: boolean; data: RFQQuote[] }> {
    const { data } = await apiClient.get(`/admin/rfqs/${id}/quotes`);
    return data;
  },
};
